import React from 'react';
import { Link } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

import companyImg from '../../assets/img/slider/gemasan-25.svg';

const Company = () => {
  let tab1 = 'Gerçek Zamanlı Tespit',
    tab2 = 'Çarpışma Önleme',
    tab3 = 'Gündüz/Gece Operasyon';
  const tabStyle = 'nav nav-tab';

  return (
    <div id="seyir-sistemi" className="company__area pb-100">
      <div className="container">
        <div className="row align-items-center">
          <div
            className="col-xl-6 wow animate__fadeInLeft"
            data-wow-duration="1.1s"
            data-wow-delay=".5s"
          >
            <div className="company__left-img text-center text-xl-start">
              <img src={companyImg} alt="" />
            </div>
          </div>
          <div
            className="col-xl-6 wow animate__fadeInRight"
            data-wow-duration="1.1s"
            data-wow-delay=".5s"
          >
            <div className="company__section-box">
              <h4 className="section-subtitle char-anim" style={{ color: '#2a3658' }}>
                Seyir Destek Sistemi
              </h4>
              <h3 className="section-title pb-10 char-anim" style={{ color: '#2a3658' }}>
                Yapay Zeka Destekli Seyir Destek Sistemi
              </h3>
              <p className="char-anim-2" style={{ color: '#2a3658' }}>
                Geliştirmekte olduğumuz Seyir Destek Sistemi, gündüz ve gece koşullarında çalışan, nesne tespiti ve takibi yaparak çarpışma risklerini önceden belirleyen otonom bir sistemdir. Deniz araçlarına gerçek zamanlı çevresel farkındalık kazandıran yapay zeka tabanlı teknolojimiz, güvenli seyir sağlamak için gelişmiş algılama teknolojileri kullanmaktadır.
              </p>
            </div>
            <Tabs>
              <div className="company__service-tab">
                <TabList className={tabStyle}>
                  <Tab>
                    <button className="btn-color-1">
                      <span>{tab1}</span>
                    </button>
                  </Tab>
                  <Tab>
                    <button className="btn-color-2">
                      <span>{tab2}</span>
                    </button>
                  </Tab>
                  <Tab>
                    <button className="btn-color-3">
                      <span>{tab3}</span>
                    </button>
                  </Tab>
                </TabList>
                <div className="tab-content" id="myTabContent">
                  <TabPanel>
                    <div className="company__tab-content-wrapper">
                      <div className="company__tab-text">
                        <h4 style={{ color: '#2a3658' }}>Gerçek Zamanlı Nesne Tespiti ve Takibi</h4>
                        <span style={{ color: '#2a3658' }}>Yapay zeka destekli görüntü işleme teknolojisi ile deniz yüzeyindeki nesneleri gerçek zamanlı olarak tespit eder ve takip eder. Sistem, gemiler, tekneler, şamandıralar ve diğer deniz araçlarını yüksek doğrulukla tanımlayarak güvenli seyir için kritik bilgiler sağlar.</span>
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel>
                    <div className="company__tab-content-wrapper">
                      <div className="company__tab-text">
                        <h4 style={{ color: '#2a3658' }}>Çarpışma Riski Önleme</h4>
                        <span style={{ color: '#2a3658' }}>Tespit edilen nesnelerin konum, hız ve yön bilgilerini analiz ederek potansiyel çarpışma risklerini önceden belirler. Sistem, güvenli mesafe hesaplamaları yaparak gemi kaptanına erken uyarılar verir ve güvenli rotalar önerir.</span>
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel>
                    <div className="company__tab-content-wrapper">
                      <div className="company__tab-text">
                        <h4 style={{ color: '#2a3658' }}>Gündüz ve Gece Operasyon Kabiliyeti</h4>
                        <span style={{ color: '#2a3658' }}>Gelişmiş sensör teknolojileri ve yapay zeka algoritmaları sayesinde hem gündüz hem de gece koşullarında etkili çalışır. Düşük ışık koşullarında ve kötü hava şartlarında bile güvenilir nesne tespiti ve takibi yaparak kesintisiz seyir desteği sağlar.</span>
                      </div>
                    </div>
                  </TabPanel>
                </div>
              </div>
            </Tabs>
            <div className="company__button">
              <Link
                to="/seyir"
                className="main-btn tp-btn-hover alt-color"
                style={{ textDecoration: 'none' }}
              >
                <span>Detaylar</span>
                <b></b>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Company;
